import urls from '../../urls';
import { route } from '../helpers';
import AppDispatcher from '../../dispatcher/AppDispatcher';
import OrderStore from '../../stores/OrderStore';
import { updateOrderCookie } from '../../utils/orderUtils';

import { ActionTypes, PointStages, CheckoutStages } from '../../constants/AppConstants';

export default route(CheckoutStages.DELIVERY, {
    getComponent(location, cb) {
        require.ensure(
            [],
            (require) => {
                cb(null, require('../../components/checkout/Delivery').default);
            },
            () => {
                // Adding fallback to prevent blank pages when the chunk is not available (I.E: after a release).
                // TODO: use a smarter way to get an updated chunk
                window.location.reload();
            },
            'delivery');
    },

    onEnter (nextState, replace) {
        const order = OrderStore.getCurrent();
        if (order.isEmpty() || !order.id) {
            if (!order.isEmpty()) {
                // A persisted order with trips but no id cannot be recovered — drop it
                // so the affected session stops crashing on every /delivery visit.
                updateOrderCookie({});
                AppDispatcher.dispatch({ actionType: ActionTypes.ORDER_EXPIRED });
            }
            replace(urls.location(PointStages.SEARCH));
        }
    }
});
